import _extends from "@babel/runtime/helpers/extends";
import { ErrorMessage, Field, HelperMessage } from '@atlaskit/form';
import TextArea from '@atlaskit/textarea';
import TextField from '@atlaskit/textfield';
import React from 'react';
const TextInput = _ref => {
  let {
    defaultValue = '',
    helperMessage,
    isCompact,
    fieldType = 'textfield',
    type,
    isRequired,
    label,
    name,
    onChange: _onChange,
    placeholder,
    validate,
    isDisabled,
    width
  } = _ref;
  const Input = fieldType === 'textarea' ? TextArea : TextField;
  return /*#__PURE__*/React.createElement(Field, {
    name: name,
    label: label,
    isRequired: isRequired,
    validate: validate,
    defaultValue: defaultValue,
    isDisabled: isDisabled
  }, _ref2 => {
    let {
      fieldProps,
      error
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, _extends({}, fieldProps, {
      isCompact: isCompact,
      type: type,
      placeholder: placeholder,
      onChange: e => {
        fieldProps.onChange(e);
        _onChange === null || _onChange === void 0 ? void 0 : _onChange(e.target.value);
      },
      width: width
    })), error && /*#__PURE__*/React.createElement(ErrorMessage, null, error), helperMessage && /*#__PURE__*/React.createElement(HelperMessage, null, helperMessage));
  });
};
export default TextInput;